import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
var VALIDATORS = {
  url: {
    message: 'The URL you entered is incorrect',
    fieldMatcher: function isUrlField(name) {
      return name.indexOf('url') !== -1;
    },
    fieldValidator: function validURL(str) {
      var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

      return !!pattern.test(str);
    }
  }
};

function getErrorElement(messages) {
  var errorElement = document.createElement('ul');
  errorElement.classList.add('hs-error-msgs', 'js-error-container');
  errorElement.setAttribute('role', 'alert');
  messages.forEach(function (m) {
    var messageElement = document.createElement('li');
    messageElement.innerHTML = '<label class="hs-error-msg">' + m + '</label>';
    errorElement.appendChild(messageElement);
  });
  return errorElement;
}

function loadLibrary(onLoad) {
  var htmlElement = document.createElement('script');
  htmlElement.src = 'https://js.hsforms.net/forms/v2.js';
  htmlElement.async = true;
  document.head.insertBefore(htmlElement, document.head.childNodes[0]);

  htmlElement.onload = function () {
    if (typeof onLoad === 'function') {
      onLoad();
    }
  };
}

var getUserEmail = function () {
  var request = {
    data: null,
    xhr: null,
    subscribers: [],
    dispatch: function dispatch(data) {
      for (var i = 0; i < request.subscribers.length; i++) {
        request.subscribers[i](data);
      }

      request.subscribers = [];
    },
    getData: function getData(callback) {
      request.subscribers.push(callback);

      if (!request.data && !request.xhr && typeof common !== 'undefined' && common.cookie.get('userInfo')) {
        request.xhr = new XMLHttpRequest();
        var url = '/api/v1/profile/?fields=email';
        request.xhr.responseType = 'json';
        request.xhr.open('GET', url);
        request.xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        request.xhr.send();
        request.xhr.addEventListener('load', function (e) {
          if (e.currentTarget.status === 200 && e.currentTarget.readyState === 4) {
            request.data = {
              email: request.xhr.response.email
            };
            request.dispatch(request.data);
          } else {
            request.dispatch({
              error: 1
            });
            request.dispatch(request.data);
          }
        });
      } else if (request.data) {
        request.dispatch(request.data);
      }
    }
  };
  return {
    getData: function getData(callback) {
      request.getData(callback);
    }
  };
}();

function loadHubSpotForm() {
  var pages = ['/smart-meetings/', '/smartmeetings/'];

  if (typeof hbspt === 'undefined') {
    loadLibrary(loadHubSpotForm);
    return;
  }

  var containers = document.querySelectorAll('.com-el-hubspot-form[data-form-id]:not(.is-initialized):not(.is-loading)');
  [].forEach.call(containers, function (container) {
    var formId = container.dataset.formId;
    var salesforceId = container.dataset.salesforceId;
    var buttonDescription = container.querySelector('.js-button-description');
    var data = {};
    var formData = [];
    var id = getRandomId();
    var elements = container.querySelector('.com-el-hubspot-form__elements');
    var formContainer = container.querySelector('.com-el-hubspot-form__container');
    var sectionName = container.closest('[data-name]').dataset.name;
    container.setAttribute('id', id);
    container.classList.add('is-loading');
    hbspt.forms.create({
      portalId: '3782705',
      formId: formId,
      sfdcCampaignId: salesforceId,
      target: '#' + id + ' .com-el-hubspot-form__container',
      css: false,
      formInstanceId: id,
      submitButtonClass: 'com-el-button',
      onFormReady: function onFormReady(form) {
        var fields = form[0].querySelectorAll('.hs-input');
        var submitWrapper = form[0].querySelector('.hs-submit');
        var tags = form[0].querySelectorAll('h1, h2, h3, h4, h5, h6, p');
        var fileFields = form[0].querySelectorAll('.hs-fieldtype-file');
        container.classList.remove('is-loading');
        container.classList.add('is-initialized');

        if (elements) {
          elements.classList.remove('is-hidden');

          if (elements.classList.contains('is-inner-elements')) {
            formContainer.insertBefore(elements, formContainer.childNodes[0]);
          }
        }

        $('.hs-fieldtype-select select').styler();
        var $selectBox = $('.jq-selectbox');
        var selectBoxText = form[0].querySelectorAll('.jq-selectbox__select-text');
        $('.jq-selectbox__dropdown li').on('click', function () {
          if ($selectBox.hasClass('opened')) {
            $selectBox.removeClass('opened');
          }
        });
        [].forEach.call(fields, function (field) {
          if (field.hasAttribute('placeholder')) {
            field.setAttribute('placeholder', field.getAttribute('placeholder').replace('*', ''));
          }

          if (field.getAttribute('name') === 'email' && pages.includes(window.location.pathname)) {
            getUserEmail.getData(function (data) {
              if (data && data.email) {
                $(field).val(data.email).change();
              }
            });
          }
        });
        [].forEach.call(selectBoxText, function (selectText) {
          selectText.innerText = selectText.innerText.replace('*', '');
        });

        if (buttonDescription) {
          buttonDescription.classList.remove('is-hidden');
          submitWrapper.appendChild(buttonDescription);
        }

        ;
        [].forEach.call(tags, function (tag) {
          if (tag.tagName === 'P') {
            tag.classList.add('com-el-content', 'com-el-content--small');
          } else if (tag.tagName === 'H1') {
            tag.classList.add('com-el-headline', 'com-el-headline--mid');
          } else {
            tag.classList.add('com-el-headline', 'com-el-headline--tiny');
          }
        });
        [].forEach.call(fileFields, function (field) {
          var inputs = field.querySelectorAll('.input');
          [].forEach.call(inputs, function (input) {
            var inputField = input.querySelector('.hs-input[type="file"]');
            var chooseFileButton = document.createElement('label');
            var chooseFileWrapper = document.createElement('div');
            var attachedFiles = document.createElement('div');
            chooseFileButton.setAttribute('for', inputField.getAttribute('id'));
            chooseFileButton.setAttribute('class', 'hs-choose-button');
            chooseFileButton.innerText = 'Choose file';
            input.appendChild(chooseFileButton);
            chooseFileWrapper.setAttribute('class', 'hs-choose-file');
            chooseFileWrapper.innerText = 'No file chosen';
            input.appendChild(chooseFileWrapper);
            attachedFiles.setAttribute('class', 'hs-attached-files');
            input.appendChild(attachedFiles);
            inputField.addEventListener('change', function () {
              var _field = this;

              if ('files' in _field) {
                for (var i = 0; i < _field.files.length; i++) {
                  var file = _field.files[i];

                  if ('name' in file) {
                    chooseFileWrapper.remove();
                    attachedFiles.innerHTML = file.name;
                  }
                }
              }
            });
          });
        });
        var formData = $(form).serializeArray();
        var fieldsToValidate = {};
        Object.keys(VALIDATORS).forEach(function (v) {
          var fieldMatcher = VALIDATORS[v].fieldMatcher;

          if (!fieldMatcher) {
            return;
          }

          formData.reduce(function (fieldsToValidate, f) {
            if (fieldMatcher(f.name)) {
              fieldsToValidate[f.name] = fieldsToValidate[f.name] || [];
              fieldsToValidate[f.name].push(v);
            }

            return fieldsToValidate;
          }, fieldsToValidate);
        });
        [].forEach.call(fields, function (field) {
          field.addEventListener('input', function (e) {
            var value = e.target.value || '';
            var name = e.target.getAttribute('name');

            if (!name || !fieldsToValidate[name] || value.trim().length === 0) {
              return;
            }

            var validatorIds = fieldsToValidate[name];
            validatorIds.forEach(function (v) {
              if (VALIDATORS[v].fieldValidator && VALIDATORS[v].fieldValidator(value)) {
                toggleError(name);
              }
            });
          });
        });
        container.querySelector('input[type="submit"]').addEventListener('click', function (e) {
          var fieldsMap = $(form).serializeArray().reduce(function (acc, f) {
            acc[f.name] = f.value;
            return acc;
          }, {});
          Object.keys(fieldsToValidate).forEach(function (name) {
            var validatorIds = fieldsToValidate[name];
            var errors = [];
            var value = fieldsMap[name] || '';
            validatorIds.forEach(function (id) {
              var hasError = value.trim().length > 0 && VALIDATORS[id].fieldValidator && !VALIDATORS[id].fieldValidator(value);

              if (hasError) {
                errors.push(VALIDATORS[id].message);
              }
            });

            if (errors.length > 0) {
              e.preventDefault();
            }

            try {
              toggleError(name, errors);
            } catch (e) {
              console.error(e);
            }
          });
        });

        function toggleError(name, errors) {
          var formField = container.querySelector('.hs_' + name);

          if (!formField) {
            throw new Error('Form field not found');
          }

          var input = formField.querySelector('.hs-input');

          if (input) {
            input.classList.remove('error');
          }

          var existingError = formField.querySelector('.js-error-container');

          if (existingError) {
            formField.removeChild(existingError);
          }

          if (errors && errors.length > 0) {
            if (input) {
              input.classList.add('error');
            }

            formField.appendChild(getErrorElement(errors));
          }
        }
      },
      onFormSubmit: function onFormSubmit(form) {
        container.classList.add('is-loading');
        formData = $(form).serializeArray();
        formData.pop();
      },
      onFormSubmitted: function onFormSubmitted(form) {
        var submittedMessage = container.querySelector('.submitted-message');
        var header = document.createElement('div');
        data.event = 'hubspot_form_submitted';
        data.form_id = formId;
        data.form_data = formData;
        data.section_name = sectionName;
        container.classList.remove('is-loading');
        formContainer.classList.add('is-submitted');

        if (elements) {
          elements.remove();
        }

        submittedMessage.classList.add('com-el-content', 'com-el-content--small', 'com-el-content--color-dark');
        header.classList.add('com-el-headline', 'com-el-headline--mid');
        header.innerText = 'Thanks!';
        submittedMessage.insertBefore(header, submittedMessage.childNodes[0]);
        window.dataLayer.push(data);
      }
    });
  });
}

function getRandomId() {
  return 'hubspot-form-' + Math.random().toString(36).substr(2, 9);
}

export default {
  init: function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var isBrowser, _common, jQuery, styler;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isBrowser = true;

              if (!isBrowser) {
                _context.next = 15;
                break;
              }

              _context.next = 4;
              return import('./common.legacy');

            case 4:
              _common = _context.sent;

              _common["default"].init();

              _context.next = 8;
              return import('jquery');

            case 8:
              jQuery = _context.sent;
              window.$ = window.jQuery = jQuery["default"];
              _context.next = 12;
              return import('./formstyler.legacy');

            case 12:
              styler = _context.sent;
              styler["default"](jQuery["default"]);
              loadHubSpotForm();

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function init() {
      return _init.apply(this, arguments);
    }

    return init;
  }()
};